import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SEGMENT_SCHEMA_QUERY_KEY} from "../queryKeys";
import {SegmentSchema} from "./types";

type Variables = {};

const getSegmentsSchema = async (): Promise<SegmentSchema> => {
  const response = await axiosReachInstance.get<SegmentSchema, AxiosResponse<SegmentSchema>>("/segments/schema");
  return response.data;
};

export const useGetSegmentsSchema = (
  variables: Variables = {},
  options?: BaseQueryOptions<SegmentSchema, Variables>
): BaseUseQueryResult<SegmentSchema> => {
  return useBaseQuery<SegmentSchema, Variables>([SEGMENT_SCHEMA_QUERY_KEY], getSegmentsSchema, variables, options);
};
